import { Mat, CV_16U, CV_32S, add, divide, Scalar } from '@techstark/opencv-js';

export default class PressureOptimize {
    movingAvg_windowSize = 5;            // tedade frame ke miangin begire
    quantize_step = 16;
    threshold = -1;              // baraye hazfe noise, maghadire kamtar ra hazf mikonad             
    doRemoveMalignantCell = true;       // hazfe noise noghteE ba moghayese ba hamsayeha
    removeMalignantCellScale = 1.3;
    FrameThreshold = 300;        // miangine frame baraye peyda kardane pa
    SkipFrames = true;                 //bere akhare buffer ya frame be frame jolo bere


    constructor() {
        this.movingAvg_MV_Frames_queue = [];
        this.settingPath = process.env.PUBLIC_URL + '/Settings';
    }

    async LoadSettings() {
        let file = `${this.settingPath}/filter.json`;
        fetch(file)
            .then(response => response.json())
            .then(data => {
                this.movingAvg_windowSize = data.movingAvg_windowSize;
                this.quantize_step = data.quantize_step;
                this.threshold = data.threshold;
                this.doRemoveMalignantCell = data.doRemoveMalignantCell;
                this.removeMalignantCellScale = data.removeMalignantCellScale;
                this.FrameThreshold = data.FrameThreshold;
                this.SkipFrames = data.SkipFrames;
            });
    }

    Optimize(inputFrame) {
        let averagedMat = new Mat(inputFrame.rows, inputFrame.cols, inputFrame.type());
        let processedFrame = new Mat();
        let removedFrame = new Mat();
        inputFrame.convertTo(processedFrame, CV_32S);
        try {
            averagedMat = this.MovingAverage(processedFrame);
        } catch (error) { }

        if (this.doRemoveMalignantCell)
            removedFrame = this.RemoveMalignantCell(averagedMat);

        // processedFrame.delete();
        averagedMat.delete();
        inputFrame.delete();
        return removedFrame;
    }

    MovingAverage(inputFrame) {
        this.movingAvg_MV_Frames_queue.push(inputFrame);
        if (this.movingAvg_MV_Frames_queue.length > this.movingAvg_windowSize)
            this.movingAvg_MV_Frames_queue.shift();

        let sumFrame = new Mat();
        this.movingAvg_MV_Frames_queue[0].copyTo(sumFrame);
        for (let idx = 1; idx < this.movingAvg_MV_Frames_queue.length; idx++) {
            add(sumFrame, this.movingAvg_MV_Frames_queue[idx], sumFrame);
        }
        
        let scalar = new Mat(sumFrame.rows, sumFrame.cols, sumFrame.type());
        scalar.setTo(new Scalar(this.movingAvg_MV_Frames_queue.length));

        divide(sumFrame, scalar, sumFrame);
        let uint16Mat = new Mat();
        sumFrame.convertTo(uint16Mat, CV_16U);

        sumFrame.delete();
        scalar.delete();
        return uint16Mat;
    }

    RemoveMalignantCell(frame) {
        const frame2 = new Mat(frame);
        for (let j = 0; j < frame.cols; j++) { //Parse on columns
            for (let i = 0; i < frame.rows; i++) {
                const dt = frame.ushortPtr(i, j)[0];
                if (dt > this.threshold) {
                    if (j !== 0 && i !== 0 && j !== frame.cols - 1 && i !== frame.rows - 1) {
                        let max = -1;
                        for (let ii = -1; ii <= 1; ii += 2) {
                            for (let jj = -1; jj <= 1; jj += 2) {
                                if (i + ii >= 0 && i + ii < frame.rows && j + jj >= 0 && j + jj < frame.cols) {
                                    const dtt = frame.ushortPtr(i + ii, j + jj)[0];
                                    if (dtt > max) max = dtt;
                                }
                            }
                        }
                        if (dt > max * this.removeMalignantCellScale) frame2.ushortPtr(i, j)[0] = max;
                    }
                }
                else {
                    frame2.ushortPtr(i, j)[0] = 0;
                }
            }
        }

        return frame2;
    }

}